// Fills {placeholders} in a translated sentence with bold text, wherever the language puts them.
import type { ComponentChildren } from 'preact';

export function bold(text: string, vars: Record<string, string>): ComponentChildren {
  const out: ComponentChildren[] = [];
  const re = /\{(\w+)\}/g;
  let last = 0;
  for (let m = re.exec(text); m; m = re.exec(text)) {
    out.push(text.slice(last, m.index));
    out.push(m[1] in vars ? <strong>{vars[m[1]]}</strong> : m[0]);
    last = m.index + m[0].length;
  }
  out.push(text.slice(last));
  return <>{out}</>;
}
